export const SKELETON_GEOMETRY = {
  // Intentional pixel exception: this value divides useWindowDimensions().height, which is
  // measured in viewport pixels rather than design-system spacing units.
  tableRowMinHeightPx: 24,
  // SkeletonLoadingBox widths use the platform spacing scale, not pixels.
  comparisonWideCellWidth: 24,
  comparisonNarrowCellWidth: 20,
} as const;
